// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatViewPage_root__37DM8","title":"ChatViewPage_title__1040S","chatView":"ChatViewPage_chatView__4mntK"};